import { ISong, ISongWithRank } from "../@types/interface.d";
import shuffle from "./shuffle";

/**
 * 全体ランキングの順（指定した種別のスコア降順）に曲を並べ替える。
 * 好みが近い曲同士が早く対戦するので、トーナメントの試合数が減る（シード）。
 * 同点の曲とランキングに載っていない曲は、発表時期で固まらないようランダムに並べる。
 */
export default function seedByRanking(
  songs: ISong[],
  ranking: ISongWithRank[],
  kind: string,
): ISong[] {
  const scoreOf = (song: ISong): number => {
    const ranked = ranking.find(v => v.id === song.id);
    return ranked ? (ranked.scores[kind] || 0) : 0;
  };
  return shuffle(songs.slice())
    .map(song => ({ song, score: scoreOf(song) }))
    .sort((a, b) => b.score - a.score)
    .map(v => v.song);
}
